import { Outlet } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ScrollProgress from '../components/ScrollProgress'

export default function SiteLayout() {
  return (
    <>
      <div className="noise" aria-hidden="true" />
      <ScrollProgress />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  )
}
